import { colLayouts } from 'constants/layout'
import { FormattedMessage } from 'locales/index'
import React from 'react'
import { VehiclePicker } from 'shared/components/common/VehiclePicker'
import { Col, Row } from '@commutifi-fe/ui'
import { FormItemInjectedProps } from 'shared/interfaces'

export interface IVehicleValue {
  modelId?: string
  engineType?: string
  model?: React.ReactNode
  make?: string
  year?: number
  genericModelId?: string
}

export interface IVehicleSelectorProps extends FormItemInjectedProps<IVehicleValue> {
  canSelectNothing?: boolean
  /**
   * See VehiclePicker.tsx for more information
   */
  isInteractive?: boolean
}

export interface IVehicleObject {
  uuid: string
  name: string
}

export const validateVehicle = (rule: any, vehicle: IVehicleValue) => {
  if (!vehicle || (!vehicle.modelId && !vehicle.genericModelId)) {
    // eslint-disable-next-line prefer-promise-reject-errors -- Legacy, can be fixed
    return Promise.reject(<FormattedMessage id="components.vehicleSelector.errors.required" />)
  }
  return Promise.resolve()
}

function VehicleSelector({ onChange, value, id, isInteractive = false }: IVehicleSelectorProps) {
  const handleOnChange = (value: IVehicleValue | null) => onChange && onChange(value)
  return (
    <VehiclePicker
      id={id}
      initialVehicle={value}
      onChange={handleOnChange}
      allowCustom={false}
      isInteractive={isInteractive}
    >
      <Row gutter={20}>
        <Col {...colLayouts['xs-12']}>
          <VehiclePicker.Year />
        </Col>
        <Col {...colLayouts['xs-12']}>
          <VehiclePicker.Make />
        </Col>
      </Row>
      <Row gutter={20}>
        <Col {...colLayouts['xs-12']}>
          <VehiclePicker.Model />
        </Col>
        <Col {...colLayouts['xs-12']}>
          <VehiclePicker.EngineType />
        </Col>
      </Row>
      <Row gutter={20}>
        <Col {...colLayouts['xs-24/sm-12']}>
          <VehiclePicker.GenericVehicleOption />
        </Col>
      </Row>
    </VehiclePicker>
  )
}

export default VehicleSelector
